import { PackagesPriceEvolutionProvider, PackagesSubmittedFiltersProvider, PackagesReportExecutionProvider } from './@contexts'
import React from "react"


export default function PackagesProviders({ children }) {


    return <PackagesReportExecutionProvider>
        <PackagesSubmittedFiltersProvider>
            <PackagesPriceEvolutionProvider>
                {children}
            </PackagesPriceEvolutionProvider>
        </PackagesSubmittedFiltersProvider>
    </PackagesReportExecutionProvider>
}

export { PackagesSubmittedFiltersContext, PackagesPriceEvolutionContext, PackagesReportExecutionContext } from "./@contexts"